import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {HttpService} from '../../../../../core';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-update-lot-status-dialog',
  templateUrl: './update-lot-status-dialog.component.html',
  styleUrls: ['./update-lot-status-dialog.component.scss']
})
export class UpdateLotStatusDialogComponent implements OnInit {

  lots = [];
  targetStatus: number;
  projectId: number;

  constructor(
    private dialogRef: MatDialogRef<any>,
    private httpService: HttpService,
    private toastrService: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    console.log(this.data)
    this.lots = this.data.lots
    this.targetStatus = this.data.targetStatus
    this.projectId = this.data.projectId
  }

  cancel() {
    this.dialogRef.close();
  }

  confirm() {

    const ids = this.lots.map(p => p.id).toString();

    const fd = new FormData();
    fd.append('id', ids);
    fd.append('status', this.targetStatus.toString());
    this.httpService.updateLotBatch(fd).subscribe((res: any) => {
      console.log(res);
      if (res.code === 1) {

        this.toastrService.success('Properties has been updated.');
        this.dialogRef.close({lots: res.data, projectId: this.projectId});
      } else if (res.code === 0) {
        this.toastrService.error('Failed to update property');
      }
    });
  }
}

